import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import inputTypes from '../../Utils/Form/FormInput/inputTypes.jsx';
import { useFormContext } from 'react-hook-form';
import XFormInput from '../../Utils/Form/XFormInput/index.jsx';

function OrganizationAdditionalProperties({ readOnly = false }) {
  const { t } = useTranslation();
  const { register } = useFormContext();

  return (
    <fieldset className='form__section'>
      <legend className='form__section-label form__section-label--3column'>
        <span>{t('additional_details')}</span>
      </legend>
      <XFormInput
        readOnly={readOnly}
        id={'address'}
        type={inputTypes.text}
        name={'client_address'}
        label={t('client_address')}
        placeholder={t('client_address')}
        ref={register('client_address')}
      />

      <XFormInput
        readOnly={readOnly}
        id={'client_reg_code'}
        type={inputTypes.text}
        name={'client_reg_code'}
        label={t('client_reg_code')}
        placeholder={t('client_reg_code')}
        ref={register('client_reg_code')}
      />

      <XFormInput
        readOnly={readOnly}
        id={'client_vat_number'}
        type={inputTypes.text}
        name={'client_vat_number'}
        label={t('client_vat_number')}
        placeholder={t('client_vat_number')}
        ref={register('client_vat_number')}
      />

      <XFormInput
        readOnly={readOnly}
        id={'client_vat_percentage'}
        type={inputTypes.text}
        name={'client_vat_percentage'}
        label={t('client_vat_percentage')}
        placeholder={t('client_vat_percentage')}
        ref={register('client_vat_percentage')}
      />
    </fieldset>
  );
}

export default OrganizationAdditionalProperties;

OrganizationAdditionalProperties.propTypes = {
  readOnly: PropTypes.bool
};
